import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import App from './Home/index';
import reportWebVitals from './reportWebVitals';
import { Button } from 'antd';
import { BrowserRouter } from "react-router-dom";
import Layout from './Home/Layout';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Layout>
            </Layout>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
